<script>
import {createEffectiveContractComment} from "../../utils/api/effectiveContractComment.api.service";
import {mapActions} from "vuex";

export default {
  name: "EffContractUmuCommentFormDialog",

  props: {
    submitText: {
      type: String,
      default: "Отправить"
    },

    title: {
      type: String,
      default: "Замечание к показателю",
    },

    cancelText: {
      type: String,
      default: "Отмена",
    },

    subtitleText: {
      type: String,
      default: "Заполните причину отмены показателя, опишите проблему подробно.",
    },

    personEffContractId: {
      type: Number,
      default: null,
    },

    show: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      content: "",
      loading: false,

      contentRules: [
        v => !!v || 'Поле обязательно',
      ],

      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
      ],
    }
  },

  methods: {

    ...mapActions({
      successSnackbarAction: "effective_contract_notification_snackbar/successSnackbarAction",
      errorSnackbarAction: "effective_contract_notification_snackbar/errorSnackbarAction",
    }),

    async createComment() {

      if (!this.$refs.EffContractCommentForm.validate()) {
        return
      }

      this.loading = true;
      const [data, error] = await createEffectiveContractComment(this.personEffContractId, this.content);

      if (!_.isNull(error)) {
        this.loading = false;
        await this.errorSnackbarAction();
        return console.warn(error);
      }

      await this.successSnackbarAction()
      this.loading = false;
      this.close()
      this.$emit('remark', this.personEffContractId, 'has_remark')
    },

    close() {
      this.resetComment();
      this.$emit('close');
    },

    resetComment() {
      this.content = "";
    },

  }

}
</script>

<template>
  <v-dialog
    :value="show"
    max-width="650px"
    content-class="rounded-xl"
    persistent
  >
    <v-card
      class="rounded-xl"
    >
      <v-card-title v-text="title"/>

      <v-card-subtitle v-text="subtitleText"/>

      <v-card-text>
        <v-form ref="EffContractCommentForm"
        >
          <v-input
            v-model="content"
            :rules="contentRules"
          >
            <vue-editor
              id="eff-contract-comment-editor"
              v-model="content"
              :editorToolbar="customToolbar"
              placeholder="Пример текста..."
              :style="{ 'width': '100%' }"
            />
          </v-input>

          <v-card-actions>
            <v-spacer/>
            <v-btn
              v-text="cancelText"
              @click="close"
              color="teal darken-3"
              class="rounded-xl"
              outlined
            />
            <v-btn
              v-text="submitText"
              @click.stop="createComment"
              :loading="loading"
              color="teal darken-3"
              class="rounded-xl"
              dark
            />
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style scoped>
</style>